import { actionCreators, reducers, selectors } from './ducks';
import CycleCreate from './presenter';
import { createCreateWatch, createEditWatch } from './sagas';

import MaxCharacters from './MaxCharacters';

export default CycleCreate;

export { createCreateWatch, createEditWatch, MaxCharacters };

export const cycleCreate = {
    reducers,
    actionCreators,
    selectors,
};
